import React from "react";
import { useSelector } from "react-redux";

const Footer = () => {
  const reduxDashboardData = useSelector(
    (state: any) => state?.dashboard?.dashboardData,
  );
  return (
    <>
      {/* Footer */}
      <div
        className="footer d-sm-flex align-items-center justify-content-center border-top bg-white p-3 bg-dark mt-5"
        style={{ fontSize: "0.84rem" }}
      >
        <div>
          <div className="d-flex align-items-center justify-content-center gap-3 mb-1">
            <div>
              User Name: {reduxDashboardData?.assignmentDetails?.full_name}
            </div>
            <div className="vr my-auto" style={{ height: 10 }}></div>
            <div>
              AccountId: {reduxDashboardData?.assignmentDetails?.case_id}
            </div>
            <div
              className="vr my-auto d-none d-md-block"
              style={{ height: 10 }}
            ></div>
            <div className="d-none d-md-block">
              Last Login:{" "}
              {reduxDashboardData?.assignmentDetails?.last_login_at
                ? new Date(
                    reduxDashboardData.assignmentDetails.last_login_at,
                  ).toLocaleString("en-GB", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                    hour: "2-digit",
                    minute: "2-digit",
                    hour12: true,
                  })
                : "-"}
            </div>
          </div>
          {/* ---- mobile ---- */}
          <div className="text-center d-md-none mb-2">
            Last Login:{" "}
            {reduxDashboardData?.assignmentDetails?.last_login_at
              ? new Date(
                  reduxDashboardData.assignmentDetails.last_login_at,
                ).toLocaleString("en-GB", {
                  day: "2-digit",
                  month: "2-digit",
                  year: "numeric",
                  hour: "2-digit",
                  minute: "2-digit",
                  hour12: true,
                })
              : "-"}
          </div>
          {/* ---- /mobile ---- */}
          <div className="d-flex flex-column flex-md-row align-items-center justify-content-md-center gap-md-3">
            {/* <div>Polities: Privacy Policy & EU/GDPR Privacy Policy</div>
            <div
              className="vr my-auto d-none d-md-block"
              style={{ height: 10 }}
            ></div> */}
            <div>
              Copyright © - {new Date().getFullYear()} Aupertz All rights
              reserved.
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;

{
  /* Footer */
}
// <div className="footer d-sm-flex align-items-center justify-content-center border-top bg-white p-3">
//   <p className="mb-0">© 2025 Aupertz. All rights reserved.</p>
// </div>
